export const channelMaterials = {
  'tiendas': [
    { id: 'material-1', stock: 100 },
    { id: 'material-9', stock: 100 },
    { id: 'material-10', stock: 100 },
    { id: 'material-11', stock: 100 },
    { id: 'material-12', stock: 100 },
    { id: 'material-14', stock: 100 },
    { id: 'material-15', stock: 100 },
    { id: 'material-16', stock: 100 },
    { id: 'material-17', stock: 100 },
    { id: 'material-18', stock: 100 },
    { id: 'material-19', stock: 100 },
    { id: 'material-20', stock: 100 },
    { id: 'material-21', stock: 100 },
  ],
  'fvd-home': [
    { id: 'material-2', stock: 100 },
    { id: 'material-13', stock: 100 },
    { id: 'material-22', stock: 100 },
    { id: 'material-23', stock: 100 },
    { id: 'material-24', stock: 100 },
  ],
  'islas': [
    { id: 'material-3', stock: 100 },
    { id: 'material-4', stock: 100 },
    { id: 'material-5', stock: 100 },
    { id: 'material-6', stock: 100 },
    { id: 'material-7', stock: 100 },
    { id: 'material-8', stock: 100 },
  ],
  'tigo-express': [
    { id: 'material-25', stock: 100 },
    { id: 'material-26', stock: 100 },
    { id: 'material-27', stock: 100 },
    { id: 'material-28', stock: 100 },
  ],
};

export const channelMaterialImportExample = [
  { materialId: 'material-1', channel: 'tiendas', stock: 100 },
  { materialId: 'material-2', channel: 'fvd-home', stock: 100 },
  { materialId: 'material-3', channel: 'islas', stock: 100 },
  { materialId: 'material-25', channel: 'tigo-express', stock: 100 },
];
